import Avatar, { AvatarSize } from "../Avatar";
import { UserIdVerifiedIcon } from "../idVerified";
import styles from "./profile.module.scss";

interface IProfileInfoCardProps {
  profile: string;
  name: string;
  phoneNumber: string;
  welcomeText?: string;
  isNavBar: boolean;
  avatarSize: AvatarSize;
  nationalIdVerified?: boolean;
}
export const ProfileInfoCard = ({
  name,
  profile,
  phoneNumber,
  welcomeText = "",
  isNavBar,
  avatarSize,
  nationalIdVerified,
}: IProfileInfoCardProps) => {
  return (
    <div dir="rtl" className={styles["profile_card__section"]}>
      <Avatar avatarSize={avatarSize} alt={name} src={profile}>
        {" "}
        <img src="" />
        <UserIdVerifiedIcon nationalIdVerified={nationalIdVerified} />
      </Avatar>
      <div className={styles["profile_details"]}>
        <div>
          <p className={"p3"}>
            {welcomeText !== "" && <span className={"p3"}>{welcomeText} </span>}
            <span className={"subtitle3"}>
              {isNavBar
                ? name.split(" ").slice(0, 1).join(" ")
                : name.split(" ")[0]}
            </span>
          </p>
          <div dir="ltr">
            <p className={styles["profile_number"]}>{phoneNumber}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
